import React from 'react';
import moment from 'moment';
import 'whatwg-fetch';

import ringAnim from '../../images/anim/ring.svg';
import withAuth from 'src/hoc/withAuth';

const apiProductShow = '/api/stepProduction/getProductHardware/';
const apiProductsShow = '/api/stepProduction/getProductsHardware/';

const oriState = {
  stepView: 1,
  dealId: undefined,
  serialNumber: undefined,
  productsOnGoing: undefined,
  productEntity: undefined,
  productSN: undefined,
  productDate: undefined,
  productWording: undefined,
  productStock: undefined,
  productSupplier: undefined,
  accordionMenuProducts: new Object(),
  pendingFetch: false,
};

class ModalLinkProductToOrder extends React.Component {
  constructor(props) {
    super(props);
    this.state = oriState;

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.reset = this.reset.bind(this);
    this.close = this.close.bind(this);
    this.showProducts = this.showProducts.bind(this);
    this.getProduct = this.getProduct.bind(this);
    this.getProducts = this.getProducts.bind(this);
    this.toggleAccordionProducts = this.toggleAccordionProducts.bind(this);
  }

  reset() {
    this.state = oriState;
    this.setState(oriState);
    this.componentDidMount();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  componentDidMount() {}

  switchStep(stepNumber) {
    this.setState({
      stepView: stepNumber,
    });
    if (stepNumber === 1) {
      this.setState({
        productsOnGoing: undefined,
        accordionMenuProducts: new Object(),
      });
    }
  }

  toggleAccordionProducts(id) {
    let accordionMenuProducts = { ...this.state.accordionMenuProducts };
    accordionMenuProducts[id] = !accordionMenuProducts[id];
    this.setState({ accordionMenuProducts });
  }

  render() {
    if (this.props.isOpen === false) return null;

    const { productsOnGoing } = this.state;
    const modalPlaceholder = this.props.isScanMultiple
      ? 'Vous pouvez entrer un ou plusieurs code-barres séparés par des retours à la ligne'
      : 'Veuillez scanner le code-barre du produit';

    return (
      <div className={'modal myModal ' + (this.props.isScanMultiple ? 'myModal-stock ' : '')}>
        <div className='modal-dialog modal-md'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h4 className='modal-title'>Associer produit</h4>
              {this.state.pendingFetch && <img src={ringAnim} />}
              <button onClick={this.close} type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            {this.state.stepView === 1 && (
              <form>
                <div className='modal-body'>
                  <div className='form-group'>
                    <label htmlFor='inputCost'>Code barre</label>
                    <textarea
                      name='serialNumber'
                      value={this.state.serialNumber}
                      onChange={this.handleInputChange}
                      type='text'
                      className='form-control'
                      placeholder={modalPlaceholder}
                    />
                  </div>
                </div>
                <div className='modal-actions'>
                  <button onClick={this.close} type='button' className='btn-link modal-action' data-dismiss='modal'>
                    Annuler
                  </button>
                  <button
                    onClick={this.handleSubmit}
                    type='button'
                    className='btn-link modal-action'
                    data-dismiss='modal'
                  >
                    <strong>Suivant</strong>
                  </button>
                </div>
              </form>
            )}

            {this.state.stepView === 2 && (
              <form>
                <div className='modal-body'>
                  {this.props.isScanMultiple ? (
                    productsOnGoing ? (
                      productsOnGoing.map((data, i) => (
                        <div key={i}>
                          <div className='cursor bold' onClick={() => this.toggleAccordionProducts(i)}>
                            <span>{'#' + data.stickerId}</span>
                            <span
                              className={
                                'icon ' +
                                (this.state.accordionMenuProducts[i]
                                  ? 'icon-chevron-thin-up '
                                  : 'icon-chevron-thin-down ')
                              }
                            ></span>
                          </div>
                          {this.state.accordionMenuProducts[i] && (
                            <div className='modalLinkProduct-infos'>
                              <span>Référence: {data.reference.wording}</span>
                              <br />
                              <span>En stock à: {data.stock.name}</span>
                              <br />
                              <span>Rentré en stock le: {moment(data.dateDelivery).format('DD-MM-YY | HH:mm')}</span>
                              <br />
                              <span>Fournisseur: {data.reference.supplierHardware.name}</span>
                            </div>
                          )}
                        </div>
                      ))
                    ) : (
                      <span>Chargement...</span>
                    )
                  ) : (
                    <div className=''>
                      <span>Code-barre: {this.state.productSN}</span>
                      <br />
                      <span>Référence: {this.state.productWording}</span>
                      <br />
                      <span>En stock à: {this.state.productStock}</span>
                      <br />
                      <span>Rentré en stock le: {moment(this.state.productDate).format('DD-MM-YY | HH:mm')}</span>
                      <br />
                      <span>Fournisseur: {this.state.productSupplier}</span>
                    </div>
                  )}
                </div>
                <div className='modal-actions'>
                  <button
                    onClick={() => this.switchStep(1)}
                    type='button'
                    className='btn-link modal-action'
                    data-dismiss='modal'
                  >
                    Précédent
                  </button>
                  <button
                    onClick={this.handleSubmit}
                    type='button'
                    className='btn-link modal-action'
                    data-dismiss='modal'
                  >
                    <strong>Ajouter</strong>
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    );
  }

  showProducts() {
    if (this.state.serialNumber && this.state.serialNumber.trim() !== '') {
      let entered = this.state.serialNumber;

      // Check integrity
      let regEx = new RegExp(/^[0-9 /\n/]+$/); // only digits & new lines
      if (regEx.test(entered)) {
        entered = entered.trim().split('\n');
        let products = [];
        for (let i = 0; i < entered.length; i++) {
          products.push(parseInt(entered[i]));
        }

        this.getProducts(products);
      } else {
        // invalid input
        this.props.openToast(false, 'Invalide. Veuillez rentrer uniquement des chiffres et des retours à la ligne');
      }
    } else {
      this.props.openToast(false, 'Veuillez remplir le champ.');
    }
  }

  getProduct() {
    // called right after the employee scanned the Serial Number
    if (this.state.serialNumber && this.state.serialNumber != '') {
      // check if id supplied in the route
      let queryURL = apiProductShow;
      let productId = parseInt(this.state.serialNumber);
      let graphQL =
        '{ product(id:' +
        productId +
        '){ ' +
        'id, stickerId, inStock, dateDelivery, reference{ id, wording, supplierHardware{ name } }, stock{ name }' +
        '} }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data['data']['product']) {
              let refIdRequired = this.props.linkRefId;
              if (data['data']['product']['inStock'] === false) {
                // check reference type
                this.props.openToast(false, 'Ce produit est déja associé');
              } else if (data['data']['product']['reference']['id'] == refIdRequired) {
                this.setState({
                  productEntity: data['data']['product'],
                  productSN: data['data']['product']['stickerId'],
                  productDate: data['data']['product']['dateDelivery'],
                  productWording: data['data']['product']['reference']['wording'],
                  productSupplier: data['data']['product']['reference']['supplierHardware']['name'],
                  productStock: data['data']['product']['stock']['name'],
                });
                this.switchStep(2);
              } else {
                this.props.openToast(false, 'Veuillez scanner un ' + this.props.linkWording);
                this.switchStep(1);
              }
            } else {
              this.props.openToast(false, 'Produit non-trouvé');
            }
            //console.log(data);
          }.bind(this)
        )
        .catch(
          function (error) {
            console.log('erreur fetch Product entity');
          }.bind(this)
        );
    } else {
      this.props.openToast(false, 'Produit non-trouvé');
    }
  }

  getProducts(products) {
    let queryURL = apiProductsShow;
    let productList = encodeURIComponent(JSON.stringify(products));
    let graphQL =
      '{ products(idList:' +
      productList +
      '){ ' +
      'id, stickerId, inStock, dateDelivery, reference{ id, wording, supplierHardware{ name } }, stock{ name }' +
      '} }';
    let data = 'data=' + graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['products']) {
            this.setState({
              productsOnGoing: data['data']['products'],
            });
            this.switchStep(2);
          } else {
            this.props.openToast(false, 'Produit non-trouvé');
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch Product entity: \n' + error);
        }.bind(this)
      );
  }

  handleSubmit() {
    if (this.state.stepView === 1) {
      if (this.props.isScanMultiple) {
        this.showProducts();
      } else {
        this.getProduct();
      }
    } else {
      let param = this.props.isScanMultiple ? this.state.productsOnGoing : this.state.productEntity['id'];
      this.props.onPost(param);
      this.close();
    }
  }

  close() {
    this.reset();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }
}

export default withAuth(ModalLinkProductToOrder);
